import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type { BonusType } from "~/modules/humanResources/api/bonusType/bonusTypes.ts";

export function indexBonusTypes(): AxiosApiResponsePromise<BonusType[]> {
	return axiosApi.get("/bonus-types");
}